@if (displayLoadingSpinner) {
  <div class="loading-overlay app-component">
    <div class="loading-spinner">
      <mat-spinner [diameter]="100"></mat-spinner>
    </div>
  </div>
}

<router-outlet></router-outlet>
